/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Turing_TitleInputs */

const en_home_quotes_turing_title = /** @type {(inputs: Home_Quotes_Turing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventor of the modern computer`)
};

/**
* | output |
* | --- |
* | "Inventor of the modern computer" |
*
* @param {Home_Quotes_Turing_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_quotes_turing_title = /** @type {((inputs?: Home_Quotes_Turing_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Turing_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_quotes_turing_title(inputs)
});